// src/components/common/Modal.jsx
import React from 'react';
import './Modal.css';

const Modal = ({ 
    isOpen, 
    onClose, 
    title, 
    icon, 
    children, 
    footer, 
    className = '',
    size = 'medium' 
}) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div 
                className={`modal modal-${size} ${className}`} 
                onClick={(e) => e.stopPropagation()}
            >
                {title && (
                    <div className="modal-header">
                        <h3>
                            {icon && <i className={icon}></i>} {title}
                        </h3>
                        <button className="modal-close" onClick={onClose}>
                            <i className="bi bi-x-lg"></i>
                        </button>
                    </div>
                )}
                <div className="modal-body">
                    {children}
                </div>
                {footer && (
                    <div className="modal-footer">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;